const AboutFounder = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10 font-lato px-6 py-10">
      <div className="space-y-6 text-center md:text-left">
        <h1 className="text-[2rem] md:text-[2.5rem] font-black">
          Meet The Founder
        </h1>
        <p className="max-w-[30rem] mx-auto md:mx-0">
          Meet Dr. Olurotimi Nosa Aderemi, the driving force behind
          Lordsforerunner. With boundless passion and visionary leadership, Dr.
          Aderemi has shaped Lordsforerunner success, inspiring innovation and
          excellence in the industry.
        </p>
      </div>

      <div className="flex flex-col items-center text-center">
        <div className="aspect-square w-48 md:w-60 place-content-center rounded-full bg-oldGreen flex items-center justify-center">
          <h1 className="text-white">Founder Picture</h1>
          {/* <img src="" alt="Founder Image" /> */}
        </div>

        <div className="mt-4 text-base">
          <p className="font-semibold">Olurotimi Nosa Aderemi</p>
          <p>Public Health and General Physician</p>
        </div>
      </div>
    </div>
  );
};

export default AboutFounder;
